import * as moment from "moment";
import NotificationBase from "../NotificationBase";
import {BillCreatedNotificationDataApiDto, NotificationBaseApiDto} from "../../../api/model/rest";

/**
 * Xero Invoice created notification class.
 */
export default class BillCreatedNotification extends NotificationBase {
	/**
	 * @param {string} id notification id.
	 * @param {moment.Moment} visibleFrom Notification datetime.
	 * @param {boolean} read flag if notification is marked as read.
	 * @param {string} type in this case always 'INVOICE_IN_XERO_CREATED'.
	 * @param {BillCreatedNotificationData} data bill created notification data object.
	 */
	constructor(readonly id: string,
		readonly visibleFrom: moment.Moment,
		readonly read: boolean,
		readonly type: string,
		readonly data: BillCreatedNotificationData) {
		super(id, visibleFrom, read, type);
	}

	static fromJson(json: NotificationBaseApiDto): BillCreatedNotification {
		return new BillCreatedNotification(json.id, moment(json.visibleFrom), json.read, json.type,
			BillCreatedNotificationData.fromJson(json.data as BillCreatedNotificationDataApiDto));
	}

	copy({id = this.id, dateTime = this.visibleFrom, read = this.read, type = this.type, data = this.data}) {
		return new BillCreatedNotification(id, dateTime, read, type, data);
	}
}

/**
 * Xero Invoice created notification class data.
 */
export class BillCreatedNotificationData {
	constructor(readonly jobRefNumber: string, readonly billId: string) {}

	static fromJson(json: BillCreatedNotificationDataApiDto): BillCreatedNotificationData {
		return new BillCreatedNotificationData(json.jobRefNumber, json.billId)
	}
}
